// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import ThemeSettings from "./components/settings";
import ScrollToTop from "./components/ScrollToTop";
import { ProgressBarStyle } from "./components/ProgressBar";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
// Sentry
import * as Sentry from "@sentry/react";

// ----------------------------------------------------------------------

export default function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '90vh',
          padding: '20px',
          fontFamily: 'sans-serif',
          textAlign: 'center'
        }}>
          <h1>Something went wrong</h1>
          <p>An error occurred.</p>
          <details style={{ marginTop: '5px', marginBottom: '40px', opacity: 0.5 }}>
            <summary>Error details</summary>
            <pre style={{ textAlign: 'left', background: '#f5f5f5', padding: '10px', marginTop: '10px' }}>
              {error?.toString()}
            </pre>
          </details>
          <button onClick={resetError} style={{ 
            padding: '10px 20px', 
            backgroundColor: '#007bff', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px',
            cursor: 'pointer'
          }}>
            Try again
          </button>
        </div>
      )}
      showDialog
    >
      <MotionLazyContainer>
        <ThemeProvider>
          <ThemeSettings>
            <ProgressBarStyle />
            <ScrollToTop />
            <Router />
          </ThemeSettings>
        </ThemeProvider>
      </MotionLazyContainer>
    </Sentry.ErrorBoundary>
  );
}
